import {useEffect} from 'react';

import {useNotifications} from '~/common/Notifications';

export const useAppNotifications = () => {
  const {showNotification} = useNotifications();
  const queryParams = new URLSearchParams(window.location.search);
  const emailVerificationResult = queryParams.get('import_api_email_verification');
  const promoSuccess = queryParams.get('promo_success');

  useEffect(() => {
    if (!emailVerificationResult && !promoSuccess) {
      return;
    }

    queryParams.delete('import_api_email_verification');
    queryParams.delete('promo_success');

    const formatQueryParams = () => {
      if (queryParams.size > 0) {
        return `?${queryParams.toString()}`;
      }
      return '';
    };

    const url = new URL(
      `${window.location.origin}${window.location.pathname}${formatQueryParams()}${
        window.location.hash
      }`
    );

    window.history.replaceState({}, '', url);

    // eslint-disable-next-line default-case
    switch (emailVerificationResult) {
      case 'expired': {
        showNotification({
          title: 'Verification code expired',
          message: `The verification code has expired. Please click the 'Resend email' button again to receive a new code.`,
          type: 'error',
        });
        break;
      }
      case 'error':
      case 'not_found': {
        showNotification({
          title: 'Incorrect verification code',
          message: `The verification code entered is incorrect. Please select the site again and click 'Resend email' to receive a new code.`,
          type: 'error',
        });
        break;
      }
      case 'site_verification_deleted': {
        showNotification({
          title: 'Site deleted',
          message: `The site has been deleted and cannot be verified at this time. Please add the site again and re-initiate the verification process.`,
          type: 'error',
        });
        break;
      }
      case 'site_verification_expired': {
        showNotification({
          title: 'Site verification expired',
          message: `The site's verification period has expired, and it cannot be verified. Please click the "Verify Again" button to re-initiate the verification process.`,
          type: 'error',
        });
        break;
      }
      case 'site_verification_rejected': {
        showNotification({
          title: 'Site blocked',
          message: `The site has been blocked and cannot be verified. If you have any questions or need assistance, please contact our customer support.`,
          type: 'error',
        });
        break;
      }
      case 'success': {
        showNotification({
          title: 'You have successfully registered',
          message: 'Now you can use the API to import data.',
          type: 'success',
        });
      }
    }

    // eslint-disable-next-line default-case
    switch (promoSuccess) {
      case 'active': {
        showNotification({
          title: 'Promotion created',
          message: 'Your promotion has been created and activated successfully.',
          type: 'success',
        });
        break;
      }
      case 'pending': {
        showNotification({
          title: 'Promotion created',
          message: 'Your promotion has been created and will be active within the next 24 hours.',
          type: 'success',
        });
      }
    }
  }, []);
};
